import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
import { useAddresses } from "../Addresses/useAddresses";
export const CheckoutContext = createContext({
    customerShippingAddresses: undefined,
    orderInfo: undefined,
    setOrderInfo: () => { },
    isPayLaterSelected: false,
    setIsPayLaterSelected: () => { },
    isDeliveryMethodSelected: false,
    setIsDeliveryMethodSelected: () => { },
    resetContext: () => { },
});
export const CheckoutContextProvider = ({ children }) => {
    // Use SWR cached address data to populate context, ensuring any updates to addresses
    // are reflected in checkout without additional API calls or state management.
    const { addressState: { addresses: customerShippingAddresses }, } = useAddresses();
    const [orderInfo, setOrderInfo] = useState();
    const [isPayLaterSelected, setIsPayLaterSelected] = useState(false);
    const [isDeliveryMethodSelected, setIsDeliveryMethodSelected] = useState(false);
    const resetContext = () => {
        setOrderInfo(undefined);
        setIsPayLaterSelected(false);
        setIsDeliveryMethodSelected(false);
    };
    return (_jsx(CheckoutContext.Provider, Object.assign({ value: {
            customerShippingAddresses,
            orderInfo,
            setOrderInfo,
            isPayLaterSelected,
            setIsPayLaterSelected,
            isDeliveryMethodSelected,
            setIsDeliveryMethodSelected,
            resetContext,
        } }, { children: children })));
};
